import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {COLORS} from '../../../../constants/colors';
import {Icon} from '../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../atoms/Icon/IconName';
import {UnstyledLink} from '../../../atoms/UnstyledLink/UnstyledLink';

export const VipLogo: FC<{
  dataTestId?: string;
  vipLandingPageUrl: string;
}> = ({dataTestId, vipLandingPageUrl}) => {
  const {t} = useTranslation();
  return (
    <VipLogoLink
      to={vipLandingPageUrl}
      data-testid="AboutNameLogoVip"
      aria-label={t('Go to the VIP page')}
    >
      <VipIcon
        asset={GenericIconName.Vip}
        fill={COLORS.Black}
        data-testid={dataTestId}
      />
    </VipLogoLink>
  );
};

const VipLogoLink = styled(UnstyledLink)`
  height: 100%;
`;

const VipIcon = styled(Icon)`
  &&& {
    width: 31px;
    height: 100%;
  }
`;
